import { render, staticRenderFns } from "./FormPurchaseInvoiceBuffer.vue?vue&type=template&id=b1810bc8"
import script from "./FormPurchaseInvoiceBuffer.vue?vue&type=script&lang=js"
export * from "./FormPurchaseInvoiceBuffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports